export default "__VITE_ASSET__CvOSncE3__"